import React from "react";
import { Container, Row, Col } from 'react-bootstrap';
import LessonsList from "./LessonsList";
import ViewLesson from "./ViewLesson";
import { LessonProvider} from "../../../context/LessonContext";

const ViewCourse = ({ courseId }) => {
  return (
    <LessonProvider courseId={courseId}>
      <Container className="pt-3">
        <Row style={{ display: 'flex', alignItems: 'stretch' }}>
          <Col md={9} sm={12} >
            <ViewLesson />
          </Col>
          <Col md={3} sm={12} className="p0" id="courselist">
          {/* <button id="menuToggle" className="hamburger">☰ Course Videos</button> */}
            <div className="course-preview-listing">
              <LessonsList />
            </div>
          </Col>
        </Row>
      </Container>
    </LessonProvider>
  );
};

export default ViewCourse;
